import { Clock, Edit2, Check, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const PendingPOs = ({ pendingPOs, onView, onApprove, onReject }) => {
  if (pendingPOs.length === 0) return null;

  return (
    <div className="bg-white border-2 border-blue-200 rounded-sm mb-8" data-testid="pending-pos-section">
      <div className="p-6 border-b border-blue-200 bg-blue-50">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-slate-900 uppercase tracking-wider" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Pending Purchase Orders
            </h2>
            <p className="text-xs text-slate-500 mt-1">Review and approve purchase orders from staff</p>
          </div>
          <Clock className="text-blue-600" size={24} />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="text-left px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">PO Number</th>
              <th className="text-left px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Supplier</th>
              <th className="text-left px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Created By</th>
              <th className="text-center px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Items</th>
              <th className="text-left px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Date</th>
              <th className="text-center px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {pendingPOs.map((po) => (
              <tr key={po.id} className="hover:bg-blue-50/50 transition-colors" data-testid={`pending-po-${po.po_number}`}>
                <td className="px-4 py-4 font-medium text-slate-900">{po.po_number}</td>
                <td className="px-4 py-4 text-slate-700">{po.supplier_name}</td>
                <td className="px-4 py-4">
                  <div>
                    <p className="font-medium text-slate-900">{po.created_by_name}</p>
                    <p className="text-xs text-slate-500 capitalize">{po.created_by_role}</p>
                  </div>
                </td>
                <td className="px-4 py-4 text-center">
                  <span className="font-bold text-slate-900">{po.items.length}</span>
                </td>
                <td className="px-4 py-4 text-slate-700 text-sm">
                  {new Date(po.created_at).toLocaleDateString()}
                </td>
                <td className="px-4 py-4">
                  <div className="flex items-center justify-center gap-2">
                    <Button size="sm" variant="outline" onClick={() => onView(po)} data-testid={`view-po-${po.po_number}`}>
                      <Edit2 size={14} className="mr-1" /> Review
                    </Button>
                    <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white" onClick={() => onApprove(po.id)} data-testid={`approve-po-${po.po_number}`}>
                      <Check size={14} />
                    </Button>
                    <Button size="sm" variant="destructive" onClick={() => onReject(po.id)} data-testid={`reject-po-${po.po_number}`}>
                      <XCircle size={14} />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { PendingPOs };
